import { Route, Routes } from 'react-router-dom';
import { hasAccessRight } from '../../utils/Functions';
import { AdminAclEnum } from '../../enum/AdminAclEnum';
import { ContractList } from './components/ContractList';
import { ContractEdit } from './components/ContractEdit';
import { ContractScheduleEdit } from './components/ContractScheduleEdit';

export function ContractRoutes() {
    return (
        <Routes>
            {hasAccessRight(AdminAclEnum.CONTRACTS) && (
                <>
                    <Route index element={<ContractList />} />
                    <Route path="edit" element={<ContractEdit />} />
                    <Route path="edit/schedule/:id" element={<ContractScheduleEdit />} />
                </>
            )}
        </Routes>
    );
}
